import React from 'react'

export const IconMenu = ({ active = false }) => {
  const color = active ? '#FFAB73' : '#878696'
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.03223 8.03906H21.0322C21.8608 8.03906 22.5322 7.36768 22.5322 6.53906C22.5322 5.71045 21.8608 5.03906 21.0322 5.03906H4.03223C3.20361 5.03906 2.53223 5.71045 2.53223 6.53906C2.53223 7.36768 3.20361 8.03906 4.03223 8.03906Z"
        fill={color}
      />
      <path
        d="M21.0322 11.0391H4.03223C3.20361 11.0391 2.53223 11.7104 2.53223 12.5391C2.53223 13.3677 3.20361 14.0391 4.03223 14.0391H21.0322C21.8608 14.0391 22.5322 13.3677 22.5322 12.5391C22.5322 11.7104 21.8608 11.0391 21.0322 11.0391Z"
        fill={color}
      />
      <path
        d="M21.0322 17.0391H4.03223C3.20361 17.0391 2.53223 17.7104 2.53223 18.5391C2.53223 19.3677 3.20361 20.0391 4.03223 20.0391H21.0322C21.8608 20.0391 22.5322 19.3677 22.5322 18.5391C22.5322 17.7104 21.8608 17.0391 21.0322 17.0391Z"
        fill={color}
      />
    </svg>
  )
}
